import TableCellSpace, { TableCellSpaceProps } from "ds/components/Table/Row/CellSpace";
import { selectColumnSize } from "ds/components/Table/store/useTableStore/selectors";

import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";
import useIacTableStore from "../../components/Table/useIacTableStore";

type IacManagementTableSpaceProps = {
  columnId: IAC_MANAGEMENTS_TABLE_COLUMNS;
} & TableCellSpaceProps;

const IacManagementTableSpace = ({ columnId, ...spaceProps }: IacManagementTableSpaceProps) => {
  // force re-render when column size changes to update the text ellipsis
  useIacTableStore((state) => selectColumnSize(state, columnId));

  return <TableCellSpace {...spaceProps} />;
};

export default IacManagementTableSpace;
